import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';

function Layout({ children }) {
  const { pathname } = useLocation();
  const isDashboardRoute = /^\/(worker|client|admin)(\/|$)/.test(pathname);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallBanner, setShowInstallBanner] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      setShowInstallBanner(true);
    };

    const handleAppInstalled = () => {
      setDeferredPrompt(null);
      setShowInstallBanner(false);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);

  const installApp = async () => {
    if (!deferredPrompt) {
      return;
    }

    deferredPrompt.prompt();
    const choiceResult = await deferredPrompt.userChoice;

    setDeferredPrompt(null);
    setShowInstallBanner(false);

    if (choiceResult.outcome === 'accepted') {
      console.log('User accepted the install prompt');
    }
  };

  const cancelInstall = () => {
    setDeferredPrompt(null);
    setShowInstallBanner(false);
  };

  return (
    <div className="min-h-screen overflow-x-hidden bg-[radial-gradient(circle_at_top_left,_rgba(255,122,0,0.16),transparent_20%),radial-gradient(circle_at_bottom_right,_rgba(11,42,74,0.08),transparent_30%),linear-gradient(180deg,#f8fafc_0%,#f1f5f9_100%)] text-slate-900">
      {!isDashboardRoute && <Navbar />}
      {showInstallBanner && (
        <div className="fixed inset-x-0 top-16 z-50 mx-auto flex max-w-7xl items-center justify-between gap-4 rounded-b-3xl border border-slate-200 bg-white/95 px-4 py-3 shadow-xl shadow-slate-200/40 backdrop-blur-sm sm:px-6">
          <div>
            <p className="text-sm font-semibold text-slate-900">Install Tuma Jobs</p>
            <p className="text-xs text-slate-500">Add the app to your device for faster access.</p>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={installApp}
              className="rounded-2xl bg-navy px-4 py-2 text-sm font-semibold text-white transition hover:bg-slate-800"
            >
              Install
            </button>
            <button
              type="button"
              onClick={cancelInstall}
              className="rounded-2xl border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
      <main className={`mx-auto max-w-7xl px-4 pb-8 sm:px-6 lg:px-8 ${isDashboardRoute ? 'pt-0' : 'pt-28'}`}>
        {children}
      </main>
      <footer className="border-t border-slate-200 bg-white/70 py-8 text-center text-slate-600">
        <p className="text-sm">© 2026 Yatu Innovations Ltd. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default Layout;